module.exports = __webpack_public_path__ + "img/hero-desktop@2x.1e89bb88.webp";